const Constants = {
  HTTP: 'http://',
  HTTPS: 'https://',
  SWAPI_ROOT: 'swapi.py4e.com/api/',
  SWAPI_PEOPLE: 'people',
  URL_IMG_PERSON: 'https://vieraboschkova.github.io/swapi-gallery/static/assets/img/people',
  GUIDE_IMG_EXTENSION: '.jpg',
};

export default Constants;
